// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "global." + chunkId + "." + {"301":"df3e8ba130d0cf48fd78","665":"2b078dd58a6192a6a626"}[chunkId] + ".js";
};